// Core
import { createAsyncThunk } from '@reduxjs/toolkit';

// Boosters
import { AxiosError } from 'axios';
import {
  ChestsResponse,
  TBuyChestResponse,
  TChestResponse,
  TChestRewardHistory,
} from '../../../types';
import { axiosInstance } from '../../index';
import { getMe } from '../profile/asyncActions';
// Types

export const getActiveChests = createAsyncThunk<ChestsResponse>(
  'chests/history/user',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get('chests/history/user');
      return data;
    } catch (error) {
      const err = error as AxiosError;
      return rejectWithValue(err);
    }
  },
);
export const getChests = createAsyncThunk('chests/get-all', async (_, { rejectWithValue }) => {
  try {
    const { data } = await axiosInstance.get('/chests');
    return data;
  } catch (error) {
    const err = error as AxiosError;
    return rejectWithValue(err);
  }
});

export const openChest = createAsyncThunk<TChestRewardHistory, {id: number}>(
  'chests/open',
  async ({ id }, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.patch(`chests/history/${id}/open`);
      return data;
    } catch (error) {
      const err = error as AxiosError;
      return rejectWithValue(err);
    }
  },
);
export const getChest = createAsyncThunk<TChestResponse, {id: string}>('chests/get-chest', async ({ id }, { rejectWithValue }) => {
  try {
    const { data } = await axiosInstance.get(`/chests/${id}`);
    return data;
  } catch (error) {
    const err = error as AxiosError;
    return rejectWithValue(err);
  }
});

export const buyChest = createAsyncThunk<TBuyChestResponse, {id: number}>('chests/buy-chest', async ({ id }, { rejectWithValue }) => {
  try {
    const { data } = await axiosInstance.get<TBuyChestResponse>(`/chests/${id}/buy`);
    return data;
  } catch (error) {
    const err = error as AxiosError;
    return rejectWithValue(err);
  }
});

export const claimChestReward = createAsyncThunk<null, {id: string | number}>('chests/claim-reward', async ({ id }, { rejectWithValue, dispatch }) => {
  try {
    await axiosInstance.patch(`/chests/history/${id}/claim`);
    await dispatch(getMe());
    return null;
  } catch (error) {
    const err = error as AxiosError;
    return rejectWithValue(err);
  }
});
